import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "clip-path": "url(#i-132013661__a)",
  viewBox: "0 0 48 48"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<defs><clipPath id=\"i-132013661__a\"><rect width=\"48\" height=\"48\" fill=\"#fff\" rx=\"16\"></rect></clipPath></defs><rect width=\"48\" height=\"48\" rx=\"16\"></rect><path fill=\"#ff5226\" d=\"M0 0h48v48H0z\"></path><path fill=\"#fd0\" d=\"M20.283 3.248-6.492 45.024H5.783l15.468-24.08-.38-.171-4.287 17.232 9.078 1.6 9.331-11.728-.504-.252-3.154 13.322 19.781-3.77-4.034-6.646-7.13 1.632.842.968 3.319-13.912-7.734-5.172-10.128 12.737.504.252 4.16-16.687z\"></path>", 4)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "yandex-market"}) } }